<div id="divMain">
  <div class="card card-default">
    <div class="card-header">
      <h3 class="card-title">Criteria</h3>

      <div class="card-tools">
        <button type="button" class="btn btn-tool" data-card-widget="collapse"><i class="fas fa-minus"></i></button>

      </div>
    </div>
    <!-- /.card-header -->
    <div class="card-body">

      <div class="row">
        <div class="col-lg-6">
          <div class="form-group">
            <label class="col-lg-4 control-label"> <b translate>ประเภทสมาชิก</b></label>

            <div class="col-lg-8">
              <select id="ddlMemberType" class="form-control">
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /.card-body -->
    <div class="card-footer">
      <button type="button" class="btn btn-primary pull-right" (click)="BeforeSearch()" role="view" translate>
        <i class="fa  fa-search"></i>&nbsp;Search
      </button>
    </div>
  </div>


  <div class="card card-default">
    <div class="card-header">
      <h3 class="card-title">Data</h3>

      <div class="card-tools">
        <button type="button" class="btn btn-tool" data-card-widget="collapse"><i class="fas fa-minus"></i></button>

      </div>
    </div>
    <!-- /.card-header -->
    <div class="card-body">
      <div>
        <button type="button" class="btn btn-default" role="add" (click)="AddNew()" translate>
          <i class="fas fa-plus colorgreen"></i>&nbsp;เพิ่ม
        </button>
        <button type="button" class="btn btn-default" role="edit" (click)="EditData()">
          <i class="fas fa-edit coloryellow"></i>&nbsp;<span translate>แก้ไข</span>
        </button>
      </div>
      <br />
      <div id="divData">
        <table id="tData" class="table table-bordered  table-hover">
          <thead>
            <tr>
              <th translate>รหัส</th>
              <th translate>ชื่อ</th>
              <th translate>วันที่แก้ไข</th>
              <th translate>ผู้แก้ไข</th>
            </tr>
          </thead>
          <tbody>
          </tbody>
        </table>
      </div>
    </div>

  </div>
</div>
<div id="divDetail" style="display: none;">
  <div class="card card-default">
    <div class="card-header">
      <h3 class="card-title">Enter Data</h3>
    </div>
    <!-- /.card-header -->
    <div class="card-body">
      <div class="row">
        <div class="col-lg-6">
          <div class="form-group">
            <label class="col-lg-4 control-label required"> <b translate>ประเภทสมาชิก</b></label>

            <div class="col-lg-8">
              <select id="ddlDlgMemberType" required class="form-control">
              </select>
            </div>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="form-group">
            <label class="col-lg-4 control-label required"> <b translate>เมนู</b></label>

            <div class="col-lg-8">
              <input id="txtDlgMenu" class="form-control" />
              <input id="txtDlgMenuId" class="form-control" style="display: none;" />
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-6">

        </div>
        <div class="col-lg-6">

          <div class="col-lg-4">
            <button type="button" class="btn btn-default" (click)="UpdatePermiss()" translate>
              <i class="fas fa-check colorgreen"></i>&nbsp;Update
            </button>
          </div>
          <div class="col-lg-8">
            <table width="100%" class="table table-bordered table-striped pull-left">
              <tr>
                <td width="20%">เพิ่ม</td>
                <td width="20%">แก้ไข</td>
                <td width="20%">ดู</td>
                <td width="20%">ลบ</td>
                <td width="20%">พิมพ์/export</td>
              </tr>
              <tr>
                <td>
                  <input type="checkbox" style="color: #17A589;" id="chkAdd" class="flat-red" name="checkbox">
                </td>
                <td>
                  <input type="checkbox" style="color: #17A589;" id="chkEdit" class="flat-red" name="checkbox">
                </td>
                <td>
                  <input type="checkbox" style="color: #17A589;" id="chkView" class="flat-red" name="checkbox">
                </td>
                <td>
                  <input type="checkbox" style="color: #17A589;" id="chkDelete" class="flat-red" name="checkbox">
                </td>
                <td>
                  <input type="checkbox" style="color: #17A589;" id="chkPrint" class="flat-red" name="checkbox">
                </td>
              </tr>
            </table>
          </div>

        </div>
      </div>



      <br>
      <div class="row">
        <div class="col-lg-5">
          All
          <div id="divDataAll" style="height: 350px; overflow-y: scroll;">

          </div>
        </div>
        <div class="col-lg-2">
          <br>
          <div class="row">
            <div class="col-md-12 col-md-offset-3">
              <button type="button" class="btn btn-default" (click)="AddAllTag()">
                <i class="fa fa-angle-double-right"></i>
              </button>
            </div>
          </div>
          <br> <br>
          <div class="row">
            <div class="col-md-12 col-md-offset-3">
              <button type="button" class="btn btn-default" (click)="RemoveAllTag()">
                <i class="fa fa-angle-double-left"></i>
              </button>
            </div>
          </div>
        </div>
        <div class="col-lg-5">
          Selected
          <div id="divDataSelect" style="height: 350px; overflow-y: scroll;"></div>
        </div>
      </div>

    </div>
    <!-- /.card-body -->
    <div class="card-footer">
      <div class="pull-right">
        <button type="button" class="btn btn-primary" role="edit" (click)="Save()" translate>
          <i class="fas fa-save"></i>&nbsp;Save
        </button>
        <button type="button" class="btn btn-default" (click)="Cancel()" translate>
          <i class="fas fa-times"></i>&nbsp;Cancel
        </button>
      </div>
    </div>
  </div>



</div>


// WEBPACK FOOTER //
// ./src/app/member/member-acount-permisstion/member-acount-permisstion.component.html